module.exports = __webpack_public_path__ + "img/bingo_ball-41.a85e846c.png";